import cn from "classnames";
import { Checkmark as CheckmarkIcon } from "@rshbintech.dboul/icons";
import { Text } from "../../../text";
import { StepButtonProps } from "./types";
import styles from "./styles.module.scss";

export const StepButton = ({
  step,
  isActive,
  isPassed,
  isDisabled,
  dataTestId,
  buttonContent,
  onClick,
}: StepButtonProps) => {
  const handleClick = () => {
    if (!isActive) {
      onClick?.(step);
    }
  };

  const stepButtonDataTestId = `${dataTestId}-button`;
  const stepCount = step + 1;

  return (
    <button
      aria-label={
        isPassed ? `${stepCount} шаг пройден` : `${stepCount} шаг не пройден`
      }
      type="button"
      className={cn(styles.button, !isPassed && buttonContent?.className, {
        [styles.active]: isActive,
        [styles.passed]: isPassed,
      })}
      data-test-id={stepButtonDataTestId}
      disabled={isDisabled}
      onClick={handleClick}
    >
      {isPassed ? (
        <CheckmarkIcon
          className={styles.icon}
          dataTestId={`${stepButtonDataTestId}-icon`}
        />
      ) : (
        buttonContent?.content || (
          <Text size="large" dataTestId={`${stepButtonDataTestId}-text`}>
            {step + 1}
          </Text>
        )
      )}
    </button>
  );
};
